import {Map, List} from 'immutable';
import {createGlobalErrorObj} from 'libs/react-widgets';
import {has} from 'lodash';

import {
  DYNAMIC_COVERAGE_ERROR,
  DYNAMIC_COVERAGE_REQUEST,
  GET_DYNAMIC_COVERAGE_LIST_DATA_SUCCESS,
  SET_DYNAMIC_COVERAGE_SHOW_ALERT,
  ERROR_ALERT,
  NO_ROW_ALERT,
} from '../actions/dynamicCoverage';

const setDynamicCoverageRequest = (state) => {
  const requestCount = state.get('_metadata').get('inProgress');

  return state.mergeDeep({
    _metadata: Map({
      error: false,
      inProgress: requestCount + 1,
      showErrorAlert: false,
      showNoRowsAlert: false,
    }),
  });
};

const setDynamicCoverageShowAlertSuccess = (state, action) => {
  const {
    type,
    value,
  } = action.payload;

  if (type === ERROR_ALERT) {
    return state.mergeDeep({
      _metadata: {
        showErrorAlert: value,
      },
    });
  } else if (type === NO_ROW_ALERT) {
    return state.mergeDeep({
      _metadata: {
        showNoRowsAlert: value,
      },
    });
  }
};

const setDynamicCoverageError = (state, action) => {
  // Fallback to hardcoded default value if components did not dispatch an action with optional parameter to specify default errors
  let defaultError = action.defaultError
    ? action.defaultError
    : 'Unable to process your query at this time. Please try again later.';

  let error = has(action, 'error.data.error')
    ? action.error.data.error
    : createGlobalErrorObj([defaultError]).data.error;

  const requestCount = state.get('_metadata').get('inProgress');

  return state.merge({
    _metadata: Map({
      inProgress: requestCount - 1,
      error,
      showErrorAlert: true,
      showNoRowsAlert: false,
    }),
  });
};

const setDynamicCoverageListSuccess = (state, action) => {
  const {
    states,
    planTypes,
    medData,
    rxData,
    lastrefresheddates,
  } = action.payload;

  // Dynamic coverage format (e.g. spravato.json): medData/rxData are arrays of { fields: [{ fieldName, value }] }
  const coveragePositions = [...(medData || []), ...(rxData || [])];

  const requestCount = state.get('_metadata').get('inProgress');

  return state.merge({
    coveragePositions: List(coveragePositions),
    states: List(states || []),
    planTypes: List(planTypes),
    // add backwards compatibility with data without refresh dates
    lastrefresheddates: lastrefresheddates ? List(lastrefresheddates) : List(),
    _metadata: Map({
      inProgress: requestCount - 1,
      error: false,
      showErrorAlert: false,
      showNoRowsAlert: true,
    }),
  });
};

export default (state = Map({
  coveragePositions: List(),
  states: List(),
  planTypes: List(),
  lastrefresheddates: List(),
  _metadata: Map({
    inProgress: 0,
    error: false,
    showErrorAlert: false,
    showNoRowsAlert: true,
  }),
}), action) => {

  switch (action.type) {
    case DYNAMIC_COVERAGE_REQUEST:
      return setDynamicCoverageRequest(state);

    case DYNAMIC_COVERAGE_ERROR:
      return setDynamicCoverageError(state, action);

    case GET_DYNAMIC_COVERAGE_LIST_DATA_SUCCESS:
      return setDynamicCoverageListSuccess(state, action);

    case SET_DYNAMIC_COVERAGE_SHOW_ALERT:
      return setDynamicCoverageShowAlertSuccess(state, action);

    default:
      return state;
  }
};
